module.exports = __webpack_public_path__ + "img/数字化订货.d81623e3.png";